import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/class-names.js';
/** Glass panel with a teal hairline border (brand.css tokens). */
export function Card({ className, ...props }) {
    return (_jsx("div", { className: cn('brand-fade rounded-2xl border bg-card text-card-foreground shadow-[var(--brand-shadow)] backdrop-blur-md transition-[box-shadow,border-color] duration-200 hover:border-[var(--brand-hairline-strong)]', className), ...props }));
}
export function CardHeader({ className, ...props }) {
    return _jsx("div", { className: cn('flex flex-col gap-1.5 p-5', className), ...props });
}
export function CardTitle({ className, ...props }) {
    return (_jsx("h3", { className: cn('font-display text-lg leading-tight font-semibold tracking-tight', className), ...props }));
}
export function CardDescription({ className, ...props }) {
    return _jsx("p", { className: cn('text-sm text-muted-foreground', className), ...props });
}
export function CardContent({ className, ...props }) {
    return _jsx("div", { className: cn('p-5 pt-0', className), ...props });
}
//# sourceMappingURL=Card.js.map